<template>
  <div class="avatar-group">
    <Avatar
      v-for="(item, index) in croppedAvatarsByLength"
      v-tooltip.bottom="{ content: item?.username, theme: 'info-tooltip-sm' }"
      :key="index"
      :src="item.picture?.pictureUrl"
      :gap="item.getInitials()"
      :style="`z-index: ${index}`"
      class="avatar-group__item is-scale-by-hover"
      bordered
    >
    </Avatar>
    <VDropdown
      v-if="lengthOfHiddenAvatars && showHiddenAvatarsTooltip"
      theme="info-tooltip-sm"
      placement="bottom"
      :triggers="hiddenAvatarsTriggers"
      :hideTriggers="hiddenAvatarsTriggers"
      :delay="0"
      :autoHide="true"
      :style="`z-index: ${numberOfVisibleUsers + 1}`"
      class="avatar-group__item"
      popperClass="avatar-group__list-tooltip"
    >
      <div
        class="avatar is-md is-bordered avatar__length is-scale-by-hover"
        @click.stop
      >
        +{{ lengthOfHiddenAvatars }}
      </div>

      <template #popper>
        <div class="avatar-group__tooltip-users custom-scroll">
          <div
            v-for="item in hiddenAvatars"
            :key="item.id"
            class="avatar-group__tooltip-user"
          >
            <Avatar
              :src="item.picture?.pictureUrl"
              :gap="item.getInitials()"
              size="sm"
              class="avatar-group__tooltip-avatar"
              bordered
            />
            <span>{{ item.fullName || item.username }}</span>
          </div>
        </div>
      </template>
    </VDropdown>
    <div
      v-else-if="lengthOfHiddenAvatars"
      :style="`z-index: ${numberOfVisibleUsers + 1}`"
      class="avatar is-md is-bordered avatar-group__item avatar__length"
    >
      +{{ lengthOfHiddenAvatars }}
    </div>
    <div v-if="!croppedAvatarsByLength.length && showEmpty">
      <Avatar
        :src="null"
        class="is-blue avatar-group__item"
        bordered
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"

import { User } from "@/models"

@Options({
  name: "AvatarGroup",
  components: {
    Avatar
  }
})
export default class AvatarGroup extends Vue {
  @Prop({ default: [] }) readonly avatars: User[]
  @Prop({ default: false }) readonly showEmpty: boolean
  /** Shows a detailed member list for the hidden-avatar counter. */
  @Prop({ default: false }) readonly showHiddenAvatarsTooltip: boolean
  /** Lets a caller use the existing detailed list on hover instead of click. */
  @Prop({ default: () => ["click"] }) readonly hiddenAvatarsTriggers: string[]

  @Prop({ default: 3 }) readonly numberOfVisibleUsers: number

  get lengthOfHiddenAvatars() {
    return this.avatars.length - this.croppedAvatarsByLength.length
  }

  get croppedAvatarsByLength() {
    if (this.avatars.length <= this.numberOfVisibleUsers) {
      return this.avatars
    }
    return this.avatars.slice(0, this.numberOfVisibleUsers - 1)
  }

  get hiddenAvatars() {
    return this.avatars.slice(this.croppedAvatarsByLength.length)
  }
}
</script>
